import { render } from "./CustomerApp.vue?vue&type=template&id=59a793fa&scoped=true&ts=true"
import script from "./CustomerApp.vue?vue&type=script&lang=ts"
export * from "./CustomerApp.vue?vue&type=script&lang=ts"

import "./CustomerApp.vue?vue&type=style&index=0&id=59a793fa&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a793fa"]])

export default __exports__